import { type OrganizationHandle } from '~/hooks/useOrganization';

export const handle: OrganizationHandle = {
  organization: (match: any) => match.data?.organization,
};
